import { render, staticRenderFns } from "./AxFilesystemRecents.vue?vue&type=template&id=037779c5&"
import script from "./AxFilesystemRecents.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemRecents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports